// @flow
import type { Element } from 'react';
import React from 'react';

// <Figure> is an *internal* component which we wrap
// all figure-like components in. Main intention is for
// consistent treatment of spacing for figures.
//
// Figure should NOT be exposed to content authors in the editor.
//
// TODO rename to InternalFigure

// Figures:
// - BoxAndWhiskerPlot
// - CartesianPlane
// - NumberLine
// - Image
// - UglyLegacyImage
// - DraftImage
// - TabularData
// - StemAndLeafPlot,
// - AlgebraicWorking
// - TwoColumnProof
// - RSLGeogebra

type Props = {|
  _removeFigureMargin?: boolean,
  children: Element<any>,
|};

const Figure = React.forwardRef<Props, HTMLElement>(
  function Figure(props, ref) {
    return (
      <figure
        ref={ref}
        style={{
          display: 'block',
          margin: props._removeFigureMargin ? 0 : '16px 0',
          breakInside: 'avoid',
        }}
      >
        {props.children}
      </figure>
    );
  },
);

export default Figure;
